import {Component, OnInit} from '@angular/core';
import {DialogModel} from '@shared/models/dialog.model';
import {
  ReferenceNotificationPreferenceType,
  ReferenceNotificationPreferenceTypes,
  ReferenceNotificationSettings
} from '@features/task-manager/collaboration/store/activity.model';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';

@Component({
    standalone: false,
    selector: 'app-reference-notification-settings',
  templateUrl: './reference-notification-settings.component.html',
  styleUrls: ['./reference-notification-settings.component.scss']
})
export class ReferenceNotificationSettingsComponent implements OnInit, IDialogView {
  data: DialogModel;
  notificationSettings: ReferenceNotificationSettings = new ReferenceNotificationSettings();
  notificationTypes = ReferenceNotificationPreferenceTypes;
  constructor() { }

  ngOnInit(): void {
    if (this.data.input.referenceNotificationSettings) {
      this.notificationSettings = this.data.input.referenceNotificationSettings;
      console.log('notification settings:', this.notificationSettings);
    }
  }

  onOkClicked(): any {
    this.data.input.referenceNotificationSettings = this.notificationSettings;
    return true;
  }

}
